import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllPastBookings = ({
  supplierId,
  accountId,
}: { supplierId?: string; accountId?: string }) => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery(PAST_BOOKINGS_QUERY, {
    variables: { tenantId, supplierId, accountId },
    fetchPolicy: "no-cache",
    skip: !supplierId,
  });

  return {
    data: data?.pastBookingsReview ?? [],
    error,
    loading,
    refetch,
  };
};

export const PAST_BOOKINGS_QUERY = gql`
  query PastBookingsReview($supplierId: String, $accountId: String, $tenantId: String) {
    pastBookingsReview(supplierId: $supplierId, accountId: $accountId, tenantId: $tenantId) {
      invoiceDetailsId
      invoice {
        invoiceId
        invoiceText
        aiSummary
        totalAmount
        currency
        dueDate
        invoiceDate
        invoiceNo
        invoiceSource
        fileBlobName
        supplierId
        split
        isPaid
        supplierMatch
        supplierMatchConfidence
        ocrReviewed
        createdAt
        status
        fileName
        reviewType
        serviceDate
        totalAmountConfidence
        serviceDateConfidence
        invoiceDateConfidence
        invoiceNoConfidence
        processingStatus
      }
      supplier {
        supplierId
        supplierName
        status
        address {
          addressId
          addressLine1
          city
          state
          postcode
          country
        }
      }
      lineItemDetails {
        lineItemDetailsId
        lineItem {
          lineItemId
          aiDescription
          amount
          invoiceId
          amountConfidence
          name
          vatRate
          startDate
          endDate
          accountJustification
          index
          description
          accountConfidence
          vatRateConfidence
          accountReviewed
          accountId
          taxCodeId
          buJustification
          taxCodeConfidence
          unlinked
        }
        expenseAccount {
          accountId
          accountNo
          accountName
          accountDescription
          accountType
          automatic
          parentAccountId
          min
          max
          buExport
          serviceDateExport
          faktor2
        }
        taxCode {
          taxCodeId
          name
          description
          datevBu
          vatRate
        }
      }
    }
  }
`;
